import {
  PushNotificationType,
  Schedule,
} from "../_shared/pushNotifications/types";
import { handleTableTime } from "../NewPushNotification/utils";

export const setSuccessColumn = (schedule: Schedule): string => {
  const total =
    schedule.numSuccess + schedule.numFailure - schedule.numOptedOut;

  switch (true) {
    case total !== 0 && schedule.status === "COMPLETED":
      return ((schedule.numSuccess / total) * 100).toFixed(2) + "%";
    case total === 0 && schedule.status === "INPROGRESS":
      return "Awaiting Completion";
    case total !== 0 && schedule.status === "INPROGRESS":
      return ((schedule.numSuccess / total) * 100).toFixed(2) + "%";
    case schedule.status === "SCHEDULED":
      return "Scheduled";
    case schedule.status === "STOP":
      return "STOPPED";
    default:
      return "";
  }
};

export const createTableRowItem = (
  scheduleDb: PushNotificationType,
  schedule: Schedule
) => {
  return {
    id: scheduleDb.id,
    ScheduleId: schedule.scheduleId,
    Name: scheduleDb.name,
    Title: scheduleDb.title,
    Body: scheduleDb.body,
    Created: handleTableTime(schedule.createdOn),
    SendDate: handleTableTime(schedule.dueOn),
    Status: schedule.status,
    Success: setSuccessColumn(schedule),
  };
};
